var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoLocalisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.484,
    height: 16.11,
    viewBox: "0 0 11.484 16.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#616a7d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.742,0A5.742,5.742,0,0,0,0,5.742c0,3.623,5.111,9.624,5.33,9.891l.307.356.105.121.105-.121.307-.356c.21-.267,5.33-6.268,5.33-9.891A5.75,5.75,0,0,0,5.742,0Zm0,14.428C4.513,12.94,1.084,8.411,1.084,5.742a4.658,4.658,0,1,1,9.317,0c0,2.669-3.429,7.165-4.658,8.686Z",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.131 3.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.883,4.28a2.595,2.595,0,1,0,1.838.763A2.6,2.6,0,0,0,6.883,4.28Zm0,3.961A1.367,1.367,0,1,1,8.25,6.875,1.367,1.367,0,0,1,6.883,8.241Z",
    transform: "translate(-4.27 -4.28)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoLocalisation);
export default __webpack_public_path__ + "static/media/picto_localisation.bd8063fe.svg";
export { ForwardRef as ReactComponent };